(function() {
  'use strict';

  angular.module('ringbaPortal').component('selectUrlParams', {
    bindings: {
      campaign: '<',
      jsTags: '<',
      integrationSettingsIdsMap: '<',
      onUpdate: '&'
    },
    controller: SelectUrlParamsController,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl:
      '/scripts/shared/components/select-url-params/select-url-params.view.html'
  });

  function SelectUrlParamsController(
    _,
    $anchorScroll,
    $filter,
    $location,
    $scope,
    $uibModal,
    accountsService,
    isMobileDevice,
    queryPathMapService,
    campaignServiceNew,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;
    const panelId = 'panel-url-parameters';

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.queryPathMapToRemove = null;
    vm.modal = null;

    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.onTagTypeChange = onTagTypeChange;
    vm.unlinkFromCampaign = unlinkFromCampaign;
    vm.activateUrlParamsActions = activateUrlParamsActions;
    vm.isDisabled = isDisabled;
    vm.hasGoogleAdsIntegration = false;
    vm.confirmQueryPathMapRemovalModal = confirmQueryPathMapRemovalModal;
    vm.cancelModal = cancelModal;

    function onInit() {
      vm.isMobileView = isMobileDevice;
    }

    function onChanges(changesObj) {
      if (changesObj.campaign) {
        _loadQueryPathMaps();
      }

      if (changesObj.jsTags || changesObj.integrationSettingsIdsMap) {
        vm.hasGoogleAdsIntegration = checkForGoogleAdsIntegration();
      }
    }

    function checkForGoogleAdsIntegration() {
      return vm.jsTags?.some(tag =>
        tag?.intSettingIds?.some(
          intSettingId =>
            vm.integrationSettingsIdsMap?.[
              utils.capFirstNLetters(intSettingId, 5)
            ]?.integration?.type?.toLowerCase() === 'googleads'
        )
      );
    }

    function isDisabled(queryPathMap) {
      if (!queryPathMap) return false;

      const { incomingQueryStringName } = queryPathMap;
      const disableParams = ['gbraid', 'gclid', 'kw', 'wbraid'];
      return (
        vm.hasGoogleAdsIntegration &&
        disableParams.includes(incomingQueryStringName)
      );
    }

    function showForm(queryPathMap) {
      if (!vm.formActive && !vm.isDisabled(queryPathMap)) {
        if (queryPathMap) {
          queryPathMap.showEditForm = true;
        } else {
          vm.showAddNewForm = true;
        }
        vm.activeActionUrlParamId = false;
        vm.formActive = true;
      }
    }

    function hideForm(event, queryPathMap) {
      if (queryPathMap) {
        queryPathMap.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
      _scrollToURLParamsPanel();
    }

    function onTagTypeChange() {
      vm.currentQueryPathMap.mapToTagName = null;
    }

    function unlinkFromCampaign(queryPathMap) {
      if (!vm.formActive && !vm.isDisabled(queryPathMap)) {
        return campaignServiceNew
          .unLink(
            accountsService.currentAccountId,
            vm.campaign.id,
            queryPathMap.id,
            'qpathmaps'
          )
          .then(function() {
            vm.onUpdate();
            _loadQueryPathMaps();
            toaster.pop('success', $filter('translate')('TAGS_REMOVE_SUCCESS'));
            vm.cancelModal();
          })
          .catch(utils.errorHandler);
      }
    }

    function activateUrlParamsActions(queryPathMapId) {
      if (!vm.formActive) {
        vm.activeActionUrlParamId =
          vm.activeActionUrlParamId == queryPathMapId ? false : queryPathMapId;
      }
    }

    function _loadQueryPathMaps() {
      queryPathMapService
        .getQueryPathMaps(accountsService.currentAccountId)
        .then(function(response) {
          vm.queryPathMaps = response.data.queryPathMaps;
          _filterLinkedQueryPathMaps();
        });
    }

    function _filterLinkedQueryPathMaps() {
      if (vm.queryPathMaps && vm.campaign) {
        vm.queryPathMaps = vm.queryPathMaps.filter(function(queryPathMap) {
          return !_.find(vm.campaign.qPathMaps, {
            id: queryPathMap.id
          });
        });
      }
    }

    function _scrollToURLParamsPanel() {
      $location.hash(panelId);
      $anchorScroll();
    }

    function confirmQueryPathMapRemovalModal(queryPathMap) {
      if (!vm.formActive && !vm.isDisabled(queryPathMap)) {
        vm.queryPathMapToRemove = queryPathMap;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/select-url-params/unlink-url-params.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.queryPathMapToRemove = null;
      }
    }

  }
})();
